import React, { useState, useEffect } from "react";
// import TextField from '@material-ui/core/TextField';
// import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
// import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
// import DatePicker from "@material-ui/lab/DatePicker";
import * as localService from "../../services/localService";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";
import { InvoiceModal as Modal } from "../../components/Modals/ModalStyles";
import warning from "../../img/Web/Spacia/t-warning 3.svg";
import { BlockerModal } from "../../components/FeedbackModall";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { TextField } from "@mui/material";
import apiService from "../../services/apiService";
import billingService from "../../services/billingService";
import logger from "../../utils/logger";
import { useAnalytics } from "../../components/Analytics";
import { AnalyticsProps } from "../../utils/analytics";
import { showApiMessage } from "../../utils/messageHandler";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../shadcn/ui/table";
import { Badge } from "../../shadcn/ui/badge";
import TablePageLayout from "../../components/TablePageLayout";
import { formatDateTime } from "../../utils/dateUtils";

import { extractCheckoutUrl } from "../../utils/subscriptionUtils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../shadcn/ui/dropdown-menu";
import {
  MoreVertical,
  CreditCard,
  Download,
  FileText,
  ArrowUpRight,
  ArrowDownLeft,
  Search as SearchIcon,
  Eye,
  X,
} from "lucide-react";
import { Button } from "../../shadcn/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../../shadcn/ui/tabs";
import { Input } from "../../shadcn/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../shadcn/ui/dialog";
import StatementRequestDialog from "../../components/StatementRequestDialog";

const Billing = () => {
  const [hasNoMobileWalletAccount, setHasNoMobileWalletAccount] = useState(false);
  const [processingInvoiceId, setProcessingInvoiceId] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const _handleShow = () => setShow(true);
  const getCurrencySymbol = item => item?.currency?.code;

  const [totalPageSize, setTotalPageSize] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [allUnpaidInvoices, setAllUnpaidInvoices] = useState([]);
  const [makeRequestForUnpaidInvoices, setMakeRequestForUnpaidInvoices] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedMonthAndYear, setSelectedMonthAndYear] = useState(new Date());
  const [monthStartDate, setMonthStartDate] = useState("");
  const [monthEndDate, setMonthEndDate] = useState("");
  const [viewInvoiceOpen, setViewInvoiceOpen] = useState(false);
  const [viewInvoiceData, setViewInvoiceData] = useState(null);
  const [viewInvoiceLoading, setViewInvoiceLoading] = useState(false);

  const [viewMode, setViewMode] = useState("list"); // 'list' | 'grid'

  const [showStatementModal, setShowStatementModal] = useState(false);

  // Add analytics tracking
  const { trackEvent } = useAnalytics();

  // Add new analytics events for billing specific actions
  const INVOICE_VIEWED = "invoice_viewed"; // New event not in mobile
  const INVOICE_DOWNLOADED = "invoice_downloaded"; // New event not in mobile
  const STATEMENT_DOWNLOADED = "statement_downloaded"; // New event not in mobile
  const INVOICE_PAYMENT_SELECTED = "invoice_payment_selected"; // New event not in mobile

  const history = useHistory();

  const getBookingsSuccessful = res => {
    logger.log(res);
    // Handle the new billing API response structure
    const invoices = res.data.data || res.data;
    setallpayments(invoices);
  };

  const [allpayments, setallpayments] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [activeTab, setActiveTab] = useState("invoices");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [_token, setToken] = useState("");
  const [_userId, setuserId] = useState("N/A");
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("ALL"); // ALL, PENDING, PAID, CANCELLED
  const [orderBy, setOrderBy] = useState("createdAt:desc");
  const [selectedInvoices, setSelectedInvoices] = useState(null);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const currentUser = localService.getUser();
    setuserId(currentUser);
    const token = "123";
    setToken(token);

    setLoading(true);

    const apiParams = {
      organizationId: currentUser.organizationId,
      page: currentPage,
      limit: 20,
      orderBy: orderBy,
    };

    if (activeTab === "invoices") {
      // Add status filter if not ALL
      if (statusFilter !== "ALL") {
        apiParams.status = statusFilter;
      }

      billingService
        .getInvoices(apiParams)
        .then(res => {
          if (res.status === 200) {
            setTotalPageSize(res.data.pagination?.totalCount || res.data.totalCount || res.data.total);
            setItemsPerPage(res.data.pagination?.limit || res.data.pageSize || res.data.limit || 10);
            getBookingsSuccessful(res);
          }
        })
        .catch(err => logger.log(err))
        .finally(() => setLoading(false));
    } else {
      // Fetch Transactions
      const txParams = {
        organizationId: currentUser.organizationId,
        page: currentPage,
        limit: 20,
        orderBy: orderBy,
      };

      const apiCall =
        debouncedSearch.trim().length > 0
          ? billingService.searchTransactions({ q: debouncedSearch, ...txParams })
          : billingService.getTransactions(txParams);

      apiCall
        .then(res => {
          if (res.status === 200) {
            const txData = res.data.data || res.data;
            setTransactions(Array.isArray(txData) ? txData : []);
            setTotalPageSize(res.data.pagination?.totalCount || res.data.totalCount || res.data.total);
            setItemsPerPage(res.data.pagination?.limit || res.data.pageSize || res.data.limit || 10);
          }
        })
        .catch(err => logger.log(err))
        .finally(() => setLoading(false));
    }
  }, [statusFilter, orderBy, activeTab, currentPage, debouncedSearch]);

  const formatDateToString = date => {
    let dateStr = null;

    if (date) {
      logger.log("about to format date: " + date + " to 'dd/MM/yyyy'");

      try {
        dateStr = moment(date).format("DD/MM/yyyy");
      } catch (e) {
        logger.log("an error occurred while formatting date to 'dd/MM/yyyy' string");
      }
    }
    return dateStr;
  };

  const handleMonthAndYearChange = value => {
    logger.log("month / year value is:", value);

    const date = new Date(value);
    const year = date.getFullYear(); // get date full year
    const month = date.getMonth(); // get month

    const startOfMonth = formatDateToString(new Date(year, month, 1));
    const endOfMoth = formatDateToString(new Date(year, month + 1, 0));

    logger.log("start of month:", startOfMonth);
    logger.log("end of month:", endOfMoth);

    setMonthStartDate(startOfMonth);
    setMonthEndDate(endOfMoth);

    setSelectedMonthAndYear(value);
  };

  const _viewPayment = async token => {
    try {
      const currentUser = localService.getUser();
      // Track invoice viewing
      trackEvent(INVOICE_VIEWED, {
        [AnalyticsProps.TRANSACTION_ID]: token,
        user_id: currentUser?.id,
      });

      const response = await apiService.downloadInvoicePdf(currentUser.id, token);
      const blobData = response.data || response;
      const url = window.URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice-${token}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // Track invoice download
      trackEvent(INVOICE_DOWNLOADED, {
        [AnalyticsProps.TRANSACTION_ID]: token,
        user_id: currentUser?.id,
      });
    } catch (error) {
      logger.error("Error downloading invoice:", error);
      // Show error toast or message to user
      showApiMessage(error, "download statement");
    }
  };

  const _pageCount = Math.ceil(totalPageSize / itemsPerPage);

  const changePage = selected => {
    const page = typeof selected === "object" ? selected.selected : selected;
    setCurrentPage(page);
  };

  const handleTabChange = newVal => {
    setActiveTab(newVal);
    setCurrentPage(1);
    setSearch("");
    setDebouncedSearch("");
  };

  const handleStatusFilterChange = newStatus => {
    setStatusFilter(newStatus);
    setCurrentPage(1); // Reset to first page
  };

  const handleSortChange = newOrderBy => {
    setOrderBy(newOrderBy);
    setCurrentPage(1); // Reset to first page
  };

  const showMakePaymentPage = () => {
    // Track invoice selection for payment
    trackEvent(INVOICE_PAYMENT_SELECTED, {
      invoice_count: selectedInvoices?.length || 0,
      [AnalyticsProps.TOTAL_AMOUNT]: totalAmount,
      [AnalyticsProps.CURRENCY]: getCurrencySymbol(selectedInvoices?.[0]),
    });

    history.push({
      pathname: "/make-payment",
      state: {
        invoiceAmount: totalAmount,
        selectedInvoices,
      },
    });
  };

  const handlePayNow = async referenceCode => {
    if (processingInvoiceId) return;

    try {
      setProcessingInvoiceId(referenceCode);
      logger.log("Initiating payment for invoice:", referenceCode);

      const response = await billingService.initiatePayment({
        reference: referenceCode,
      });

      const checkoutUrl = extractCheckoutUrl(response);

      if (checkoutUrl) {
        // Redirect to checkout URL
        window.location.href = checkoutUrl;
      } else {
        showApiMessage({ message: "Payment initiated successfully" }, "pay invoice");
        // Refresh invoices
        changePage(currentPage);
      }
    } catch (err) {
      logger.error("Failed to initiate payment:", err);
      showApiMessage(err, "pay invoice");
    } finally {
      setProcessingInvoiceId(null);
    }
  };

  const handleViewInvoice = async invoiceId => {
    setViewInvoiceOpen(true);
    setViewInvoiceData(null);
    setViewInvoiceLoading(true);
    try {
      const res = await billingService.getInvoiceById(invoiceId);
      if (res.status === 200) {
        setViewInvoiceData(res.data?.data || res.data);
      }
    } catch (err) {
      logger.error("Failed to load invoice:", err);
      showApiMessage(err, "fetch invoice");
      setViewInvoiceOpen(false);
    } finally {
      setViewInvoiceLoading(false);
    }
  };

  const _displayMobileWalletAccountSetupPage = () => {
    history.push("/settings/momopayment");
  };

  useEffect(() => {
    const currentUser = localService.getUser();
    const _userId = currentUser?.id;

    if (show) {
      // make ajax call for all unpaid invoices
      setMakeRequestForUnpaidInvoices(true);

      billingService
        .getInvoices({
          organizationId: currentUser.organizationId,
          status: "PENDING",
          includeRelations: true,
        })
        .then(res => {
          if (res.status === 200) {
            setMakeRequestForUnpaidInvoices(false);

            logger.log("invoices:", res.data);
            const invoices = res.data.data || res.data;
            const allUnPaidInvoices = invoices.filter(invoice => {
              return invoice.status === "PENDING";
            });

            setAllUnpaidInvoices(allUnPaidInvoices);

            logger.log("all unpaid invoices:", allUnPaidInvoices);
          }
        })
        .catch(res => {
          setMakeRequestForUnpaidInvoices(false);

          setAllUnpaidInvoices([]);
          logger.log(res);
        });
    }
  }, [show]);

  const _showInvoiceModal = () => {
    setShow(true);
  };

  // Status color variations based on payment status
  const getStatusColor = status => {
    if (!status) return "bg-gray-200 text-gray-700 hover:bg-gray-200";

    switch (status.toUpperCase()) {
      case "PENDING":
        return "bg-amber-100 text-amber-800 hover:bg-amber-100";
      case "PAID":
        return "bg-green-100 text-green-800 hover:bg-green-100";
      case "CANCELLED":
        return "bg-gray-100 text-gray-800 hover:bg-gray-100";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-100";
    }
  };

  const renderResultForUnpaidInvoices = () => {
    let whatToRender = "";

    if (makeRequestForUnpaidInvoices) {
      whatToRender = (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <div className="h-6 w-32 bg-gray-200 animate-pulse rounded" />
            <div className="h-6 w-24 bg-gray-200 animate-pulse rounded" />
          </div>
          <div className="overflow-hidden rounded-xl border border-gray-200">
            <div className="grid grid-cols-4 bg-gray-50">
              {Array.from({ length: 4 }).map((_, idx) => (
                <div key={`head-skel-${idx}`} className="px-6 py-3">
                  <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                </div>
              ))}
            </div>
            <div className="divide-y divide-gray-100 bg-white">
              {Array.from({ length: 5 }).map((_, rowIdx) => (
                <div key={`row-skel-${rowIdx}`} className="grid grid-cols-4 px-6 py-4 gap-4">
                  <div className="h-4 w-12 bg-gray-200 animate-pulse rounded" />
                  <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                  <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                  <div className="h-4 w-6 bg-gray-200 animate-pulse rounded-full" />
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    } else if (!makeRequestForUnpaidInvoices && allUnpaidInvoices.length === 0) {
      whatToRender = (
        <div className="flex justify-center items-center py-16">
          <p className="text-xl font-bold text-gray-700">No Unpaid Invoices</p>
        </div>
      );
    } else if (!makeRequestForUnpaidInvoices && allUnpaidInvoices.length > 0) {
      whatToRender = (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Number
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Value
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Date
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Check All &nbsp;
                  <input
                    type="checkbox"
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    onChange={e => {
                      const isChecked = e.currentTarget.checked;
                      logger.log("is checked?", isChecked);

                      // select all checkboxes
                      const allInvoiceCheckboxes = document.querySelectorAll(".invoice-check");
                      allInvoiceCheckboxes.forEach(checkbox => {
                        checkbox.checked = isChecked;
                      });

                      if (isChecked) {
                        const selectedInvoicesAmount = allUnpaidInvoices
                          .map(o => parseFloat(o.amount || o.netAmount || 0))
                          .reduce((val1, val2) => val1 + val2, 0);
                        logger.log("selected invoices amount:", selectedInvoicesAmount);
                        setTotalAmount(selectedInvoicesAmount);
                        setSelectedInvoices(allUnpaidInvoices);
                      } else {
                        setTotalAmount(0);
                        setSelectedInvoices(null);
                      }
                    }}
                  />
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {allUnpaidInvoices.map((unpaidInvoice, index) => {
                const amount =
                  unpaidInvoice.amount?.toLocaleString() || unpaidInvoice.netAmount?.toLocaleString() || "0";
                const invoiceValue = `${amount} ${getCurrencySymbol(unpaidInvoice)}`;

                return (
                  <tr key={unpaidInvoice.referenceCode || index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{invoiceValue}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {moment(unpaidInvoice.createdAt || unpaidInvoice.createdOn).format("DD-MMM-YYYY")}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <input
                        type="checkbox"
                        className="invoice-check h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        onChange={e => {
                          const _checked = (allUnpaidInvoices.find(
                            o => o.referenceCode === unpaidInvoice.referenceCode
                          ).checked = e.target.checked);
                          const selectedInvoicesAmount = allUnpaidInvoices
                            .filter(o => o.checked === true)
                            .map(o => parseFloat(o.amount || o.netAmount || 0))
                            .reduce((val1, val2) => val1 + val2, 0);
                          logger.log("selected invoices amount:", selectedInvoicesAmount);
                          setTotalAmount(selectedInvoicesAmount);

                          const selectedInvoices = allUnpaidInvoices.filter(o => o.checked === true).map(o => o);
                          setSelectedInvoices(selectedInvoices);
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }

    return whatToRender;
  };

  return (
    <>
      <TablePageLayout
        title="Billing"
        loading={false}
        rightActions={
          <Button
            onClick={() => setShowStatementModal(true)}
            variant="outline"
            size="sm"
            className="flex items-center gap-2"
          >
            <FileText className="w-4 h-4" />
            Request Statement
          </Button>
        }
        showSearch={activeTab === "transactions"}
        searchValue={search}
        onSearchChange={e => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }}
        searchPlaceholder="Search transactions..."
        filters={
          activeTab === "invoices"
            ? [
                {
                  id: "status-filter",
                  value: statusFilter,
                  onChange: handleStatusFilterChange,
                  options: [
                    { value: "ALL", label: "All Invoices" },
                    { value: "PENDING", label: "Pending" },
                    { value: "PAID", label: "Paid" },
                    { value: "CANCELLED", label: "Cancelled" },
                  ],
                },
              ]
            : []
        }
        showOrderBy={true}
        orderBy={orderBy}
        onOrderByChange={handleSortChange}
        orderByOptions={[
          { value: "createdAt:desc", label: "Newest First" },
          { value: "createdAt:asc", label: "Oldest First" },
        ]}
        showPagination={totalPageSize > 0}
        currentPage={currentPage}
        totalCount={totalPageSize}
        pageSize={itemsPerPage}
        onPageChange={changePage}
        viewMode={activeTab === "invoices" ? viewMode : undefined}
        onViewModeChange={activeTab === "invoices" ? setViewMode : undefined}
        viewOptions={activeTab === "invoices" ? ["list", "grid"] : []}
        bottomContent={
          <div className="pt-2">
            <Tabs value={activeTab} onValueChange={handleTabChange}>
              <TabsList className="bg-gray-100 p-1 rounded-full inline-flex">
                <TabsTrigger
                  value="invoices"
                  className="rounded-full px-6 py-1.5 data-[state=active]:bg-white data-[state=active]:shadow-sm"
                >
                  Invoices
                </TabsTrigger>
                <TabsTrigger
                  value="transactions"
                  className="rounded-full px-6 py-1.5 data-[state=active]:bg-white data-[state=active]:shadow-sm"
                >
                  Transactions
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
        }
      >
        {loading ? (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="h-6 w-28 bg-gray-200 animate-pulse rounded" />
              <div className="h-6 w-20 bg-gray-200 animate-pulse rounded" />
            </div>
            <div className="overflow-hidden rounded-xl border border-gray-200">
              <div className="grid grid-cols-7 bg-gray-50">
                {(activeTab === "invoices"
                  ? ["Invoice", "Description", "Amount", "Date", "Created By", "Type", "Status"]
                  : ["ID", "Narration", "Amount", "Balance After", "Date", "Type"]
                ).map(label => (
                  <div key={label} className="px-4 py-3">
                    <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                  </div>
                ))}
              </div>
              <div className="divide-y divide-gray-100 bg-white">
                {Array.from({ length: 6 }).map((_, idx) => (
                  <div
                    key={`billing-skel-${idx}`}
                    className={`grid ${activeTab === "invoices" ? "grid-cols-7" : "grid-cols-6"} px-4 py-3 items-center gap-4`}
                  >
                    <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                    <div className="space-y-1">
                      <div className="h-4 w-32 bg-gray-200 animate-pulse rounded" />
                      <div className="h-3 w-24 bg-gray-200 animate-pulse rounded" />
                    </div>
                    <div className="h-4 w-20 bg-gray-200 animate-pulse rounded" />
                    <div className="space-y-1">
                      <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                      <div className="h-3 w-20 bg-gray-200 animate-pulse rounded" />
                    </div>
                    <div className="space-y-1">
                      <div className="h-4 w-28 bg-gray-200 animate-pulse rounded" />
                      <div className="h-3 w-24 bg-gray-200 animate-pulse rounded" />
                    </div>
                    <div className="h-6 w-20 bg-gray-200 animate-pulse rounded-full" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (activeTab === "invoices" ? allpayments.length === 0 : transactions.length === 0) ? (
          <div className="text-center py-16">
            <p className="text-muted-foreground">No {activeTab} found</p>
          </div>
        ) : activeTab === "invoices" ? (
          viewMode === "grid" ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {allpayments.map((payment, index) => (
                <div
                  key={payment.id || index}
                  className="bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow p-5 flex flex-col gap-3"
                >
                  {/* Header row */}
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-wide">Invoice #</p>
                      <p className="text-sm font-mono font-semibold text-blue-600">{payment.referenceCode}</p>
                    </div>
                    <Badge variant="default" className={getStatusColor(payment.status)}>
                      {payment.status}
                    </Badge>
                  </div>
                  {/* Description */}
                  {payment.description && <p className="text-sm text-gray-600 line-clamp-2">{payment.description}</p>}
                  {/* Amount + Type */}
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-bold text-gray-900">
                      {payment.amount} {getCurrencySymbol(payment)}
                    </span>
                    <Badge variant="secondary" className="bg-blue-50 text-blue-700 text-xs">
                      {payment.productType}
                    </Badge>
                  </div>
                  {/* Date */}
                  <div className="text-xs text-gray-500">
                    {formatDateTime(payment.createdAt)?.date} · {formatDateTime(payment.createdAt)?.time}
                  </div>
                  {/* Divider */}
                  <div className="border-t border-gray-100" />
                  {/* Actions */}
                  <div className="flex gap-2">
                    {payment.status === "PENDING" && (
                      <Button
                        size="sm"
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white text-xs"
                        onClick={() => handlePayNow(payment.referenceCode)}
                        disabled={!!processingInvoiceId}
                      >
                        <CreditCard className="mr-1 h-3 w-3" />
                        {processingInvoiceId === payment.referenceCode ? "Processing..." : "Pay Now"}
                      </Button>
                    )}
                    <Button
                      size="sm"
                      variant="outline"
                      className={`${payment.status === "PENDING" ? "" : "flex-1"} text-xs`}
                      onClick={() => handleViewInvoice(payment.id)}
                    >
                      <Eye className="mr-1 h-3 w-3" />
                      View
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="hover:bg-transparent">
                    <TableHead className="font-semibold">Invoice #</TableHead>
                    <TableHead className="font-semibold">Description</TableHead>
                    <TableHead className="font-semibold">Amount</TableHead>
                    <TableHead className="font-semibold">Date</TableHead>
                    <TableHead className="font-semibold">Created By</TableHead>
                    <TableHead className="font-semibold">Type</TableHead>
                    <TableHead className="font-semibold">Status</TableHead>
                    <TableHead className="font-semibold text-right">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {allpayments.map((payment, index) => {
                    return (
                      <TableRow key={payment.id || index} className="hover:bg-muted/50">
                        <TableCell>
                          <span className="text-sm font-mono text-primary font-medium">{payment.referenceCode}</span>
                        </TableCell>
                        <TableCell>
                          <div className="max-w-[200px]">
                            <div className="text-sm text-gray-900 truncate" title={payment.description}>
                              {payment.description}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <span className="font-semibold text-gray-900">
                            {payment.amount} {getCurrencySymbol(payment)}
                          </span>
                        </TableCell>
                        <TableCell>
                          <div className="text-sm">
                            <div className="font-medium">{formatDateTime(payment.createdAt).date}</div>
                            <div className="text-xs text-muted-foreground">
                              {formatDateTime(payment.createdAt).time}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="text-sm">
                            <div className="text-gray-900 font-medium">
                              {payment.creator?.name ||
                                `${payment.user?.firstName || ""} ${payment.user?.lastName || ""}`.trim() ||
                                "Unknown"}
                            </div>
                            <div className="text-xs text-muted-foreground">
                              @{payment.creator?.username || payment.user?.username || "unknown"}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Badge variant="secondary" className="bg-blue-100 text-blue-800 hover:bg-blue-100">
                            {payment.productType}
                          </Badge>
                        </TableCell>
                        <TableCell>
                          <Badge variant="default" className={getStatusColor(payment.status)}>
                            {payment.status}
                          </Badge>
                        </TableCell>
                        <TableCell className="text-right">
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                                <MoreVertical className="h-4 w-4" />
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                              {payment.status === "PENDING" && (
                                <>
                                  <DropdownMenuItem
                                    onClick={() => handlePayNow(payment.referenceCode)}
                                    disabled={!!processingInvoiceId}
                                    className="text-green-600 focus:text-green-600 focus:bg-green-50"
                                  >
                                    <CreditCard className="mr-2 h-4 w-4" />
                                    {processingInvoiceId === payment.referenceCode ? "Processing..." : "Pay Now"}
                                  </DropdownMenuItem>
                                  <DropdownMenuSeparator />
                                </>
                              )}
                              <DropdownMenuItem onClick={() => handleViewInvoice(payment.id)}>
                                <Eye className="mr-2 h-4 w-4" />
                                View Invoice
                              </DropdownMenuItem>
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )
        ) : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent">
                  <TableHead className="font-semibold">Transaction #</TableHead>
                  <TableHead className="font-semibold">Narration</TableHead>
                  <TableHead className="font-semibold">Amount</TableHead>
                  <TableHead className="font-semibold">Balance After</TableHead>
                  <TableHead className="font-semibold">Date</TableHead>
                  <TableHead className="font-semibold">Type</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {transactions.map((tx, index) => {
                  const isCredit = tx.type === "CREDIT";
                  return (
                    <TableRow key={tx.id || index} className="hover:bg-muted/50">
                      <TableCell>
                        <span className="text-sm font-mono text-primary font-medium">{tx.id}</span>
                      </TableCell>
                      <TableCell>
                        <div className="max-w-[300px]">
                          <div className="text-sm text-gray-900 truncate" title={tx.narration}>
                            {tx.narration}
                          </div>
                          <div className="text-xs text-muted-foreground truncate" title={tx.reason}>
                            {tx.reason}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div
                          className={`font-semibold flex items-center ${isCredit ? "text-green-600" : "text-red-600"}`}
                        >
                          {isCredit ? (
                            <ArrowUpRight className="w-3 h-3 mr-1" />
                          ) : (
                            <ArrowDownLeft className="w-3 h-3 mr-1" />
                          )}
                          {tx.amount} {getCurrencySymbol(tx)}
                        </div>
                      </TableCell>
                      <TableCell>
                        <span className="text-sm text-gray-600">
                          {tx.balanceAfter} {getCurrencySymbol(tx)}
                        </span>
                      </TableCell>
                      <TableCell>
                        <div className="text-sm">
                          <div className="font-medium">{formatDateTime(tx.createdAt).date}</div>
                          <div className="text-xs text-muted-foreground">{formatDateTime(tx.createdAt).time}</div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <Badge
                          variant="secondary"
                          className={isCredit ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}
                        >
                          {tx.type}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        )}
      </TablePageLayout>

      {/* Select Invoice Modal */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Select Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-5">
          <div className="flex flex-col md:flex-row justify-between items-center mb-6 border-b border-gray-200 pb-4">
            <h2 className="text-xl font-medium text-gray-800">
              Total:{" "}
              <span className="text-blue-600">
                {getCurrencySymbol(allUnpaidInvoices[0])} {totalAmount}
              </span>
            </h2>
            <button
              type="button"
              className={`mt-4 md:mt-0 px-6 py-2 rounded-md text-sm font-medium focus:outline-none transition-colors ${
                !selectedInvoices || (selectedInvoices && selectedInvoices.length <= 0)
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
              }`}
              disabled={!selectedInvoices || (selectedInvoices && selectedInvoices.length <= 0)}
              onClick={showMakePaymentPage}
            >
              Continue to Payment
            </button>
          </div>
          {renderResultForUnpaidInvoices()}
        </Modal.Body>
      </Modal>

      {/* No Mobile Wallet Modal */}
      <BlockerModal
        title="Sorry"
        isOpen={hasNoMobileWalletAccount}
        isClose={() => setHasNoMobileWalletAccount(false)}
        onSubmit={() => history.push("/settings/momopayment")}
        doneButton="Account Setup"
      >
        <div className="text-center">
          <p className="text-gray-600 font-normal mb-4">
            Whoa! You do not have a mobile wallet account set up. Please click on the button below to set up a mobile
            wallet account
          </p>
          <img src={warning} alt="warning" className="mx-auto w-16 h-16" />
        </div>
      </BlockerModal>

      {/* View Invoice Dialog */}
      <Dialog open={viewInvoiceOpen} onOpenChange={setViewInvoiceOpen}>
        <DialogContent className="sm:max-w-[600px] rounded-2xl">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold text-gray-900">Invoice Details</DialogTitle>
          </DialogHeader>
          {viewInvoiceLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
          ) : viewInvoiceData ? (
            <div className="space-y-5 py-2">
              {/* Header info */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Reference</p>
                  <p className="font-semibold text-gray-900 text-sm">{viewInvoiceData.referenceCode || "—"}</p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Status</p>
                  <Badge className={getStatusColor(viewInvoiceData.status)}>{viewInvoiceData.status}</Badge>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Amount</p>
                  <p className="font-bold text-gray-900">
                    {viewInvoiceData.amount} {getCurrencySymbol(viewInvoiceData)}
                  </p>
                </div>
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Type</p>
                  <p className="font-semibold text-gray-900 text-sm">{viewInvoiceData.productType || "—"}</p>
                </div>
              </div>
              {/* Description */}
              {viewInvoiceData.description && (
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Description</p>
                  <p className="text-sm text-gray-800">{viewInvoiceData.description}</p>
                </div>
              )}
              {/* Dates */}
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Created</p>
                  <p className="text-sm text-gray-800">{formatDateTime(viewInvoiceData.createdAt)?.date}</p>
                  <p className="text-xs text-gray-500">{formatDateTime(viewInvoiceData.createdAt)?.time}</p>
                </div>
                {viewInvoiceData.paymentCompletedAt && (
                  <div className="bg-green-50 rounded-xl p-4">
                    <p className="text-xs text-green-600 uppercase tracking-wide mb-1">Paid On</p>
                    <p className="text-sm text-green-800">{formatDateTime(viewInvoiceData.paymentCompletedAt)?.date}</p>
                  </div>
                )}
              </div>
              {/* Invoice Items */}
              {viewInvoiceData.invoiceItems?.length > 0 && (
                <div>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mb-2">Line Items</p>
                  <div className="border rounded-xl overflow-hidden">
                    {viewInvoiceData.invoiceItems.map((item, i) => (
                      <div
                        key={i}
                        className={`flex justify-between items-center px-4 py-3 text-sm ${i !== viewInvoiceData.invoiceItems.length - 1 ? "border-b" : ""}`}
                      >
                        <span className="text-gray-700">{item.description}</span>
                        <span className="font-semibold text-gray-900">
                          {item.amount} {getCurrencySymbol(viewInvoiceData)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* Pay Now if pending */}
              {viewInvoiceData.status === "PENDING" && (
                <Button
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-5"
                  onClick={() => {
                    setViewInvoiceOpen(false);
                    handlePayNow(viewInvoiceData.referenceCode);
                  }}
                  disabled={!!processingInvoiceId}
                >
                  <CreditCard className="mr-2 h-4 w-4" />
                  Pay Now
                </Button>
              )}
            </div>
          ) : null}
        </DialogContent>
      </Dialog>

      {/* Statement Request Dialog */}
      <StatementRequestDialog
        open={showStatementModal}
        onOpenChange={setShowStatementModal}
        onSuccess={() => {
          // No-op for now, as Billing doesn't show a list of requests
        }}
      />
    </>
  );
};

export default Billing;
